<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
         قالب پیامک ثبت سند
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="2"
                 v-if="can('newDailyAccountSms')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <page-edit  v-model="model" :item-list="itemList" :audience-list="audienceList" :building-list="buildingList" :dialogStatus.sync="showDialog"/>
          </v-col>
          <v-col cols="12"
                 sm="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                placeholder="نام مجتمع"
                v-model="searchvalue"


            />
            <v-btn  fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12" md="6" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>
        <v-spacer/>
        <b-table
            v-if="can('dailyAccountSmsList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped
        >
          <template #cell(statusText)="row">
            <v-chip :color="row.item.color" label outlined small>{{ row.item.statusText }}</v-chip>
          </template>
          <template #cell(actions)="row">
            <v-btn depressed small v-if="can('editDailyAccountSms')" color="primary" @click="forEdit(row.item)" class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteDailyAccountSms')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PageEdit from './PageEdit'
import Service_se from "./Service_se";
import {mapMutations} from "vuex";

export default {
  name: 'DailyAccountSms',
  components: {
    PageEdit
  },
  data() {
    return {
      searchvalue: '',
      modelId: '',
      data: {},
      showDialog: false,
      model: {},
      buildingList: [],
      itemList: [],
      audienceList: [],
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'building', label: 'مجتمع', sortable: true, sortDirection: 'desc'},
        {key: 'statusText', label: 'وضعیت',},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('DailyAccountSms', () => {
      this.fillDataItems()
    })

  },

  methods: {
    close(){
      this.searchvalue=""
      this.$root.$emit('DailyAccountSms')
      this.$router.push('/home')
    },

    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    fetch() {
      Service_se.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.buildingList = response.data.buildingList
        this.itemList = response.data.itemList
        this.audienceList = response.data.audienceList
      })
      this.showDialog = true;
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()
    },

    forNew: function () {
      this.data = {};
      this.modelId = '';
      this.fetch()
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Service_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
       Service_se.getPage(this.searchvalue,this.skip - 1, this.take).then(response => {
        this.paging = response.data.page
        this.dataItems = response.data.list

      });
    },

    search(){
      this.skip=0
      this.take=10
      this.fillDataItems()
    }
  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
